// extracted by mini-css-extract-plugin
export default {"splashScreen":"splash_screen_splashScreen__oCjhV","fade-out":"splash_screen_fade-out__Sg9-D"};